import { render, staticRenderFns } from "./DocumentsModal.vue?vue&type=template&id=193addb6&scoped=true&"
import script from "./DocumentsModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsModal.vue?vue&type=style&index=0&id=193addb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193addb6",
  null
  
)

export default component.exports